import {
    Container,
    Card,
    Row,
    Col,
    Form,
    ButtonGroup,
    Button,
    Image
} from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttachments } from "../../3.Store/ReviewMedicalClaimsSlice";
import { ThreeDots } from 'react-loader-spinner';
import jsPDF from 'jspdf';
import { getListDetails, getReviewClaimsPagination, SUapproveLeave, SUrejectLeave } from "../../3.Store/SUReviewClaimSlice";
import PDFViewer from "../../2.Commons/PDFViewer";
import DatePicker from "react-datepicker";
  
  const SUReviewClaimForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const details = useSelector(state => state.SUReviewClaimSlice.list);
    const attachment = useSelector(state => state.ReviewMedicalClaimsSlice.attachment);
    const currentPage = useSelector(state => state.SUReviewClaimSlice.currentPage);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      window.scrollTo(0, 0);
      setLoading(true);
      if (id) {
        dispatch(getReviewClaimsPagination({currentPage}))
        dispatch(getAttachments({id}))
        .then(() => {
            setLoading(false);
            dispatch(getListDetails(id));
        })
        .catch(() => {
            setLoading(false);
        });
    }
    }, [id]);
  
    const handleBtnReject = () => {
      if (details.status.description === 'APPROVED-HR') {
        Swal.fire('', 'The leave request has been approved by HR.', 'info');
        return;
      }
      else if (details.status.description === 'REJECTED-HR') {
        Swal.fire('', 'The leave request has been rejected by HR.', 'info');
        return;
      }

      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          dispatch(SUrejectLeave({id}))
            .unwrap()
            .then(() => {
              setLoading(false);
              Swal.fire("Leave Rejected", "", "success", "OK")
              .then(() => {
                navigate(`/SUReviewClaimList`);
              })
            })
            .catch((err) => {
              setLoading(false);
              Swal.fire("Error", err.response.data, "error", "OK");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              'Cancelled',
              'The rejection has been cancelled',
              'error'
            );
        }
      });
    };
  
    const handleBtnBack = () => {
      navigate(`/SUReviewClaimList`);
    };

    const handleBtnApprove = () => {
      if (details.status.description === 'APPROVED-HR') {
        Swal.fire('', 'The leave request has been approved by HR.', 'info');
        return;
      }
      else if (details.status.description === 'REJECTED-HR') {
        Swal.fire('', 'The leave request has been rejected by HR.', 'info');
        return;
      }
  
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          dispatch(SUapproveLeave({id}))
            .unwrap()
            .then(() => {
              setLoading(false);
              Swal.fire("Leave Approved", "", "success", "OK").then(() => {
                navigate(`/SUReviewClaimList`);
              });
            })
            .catch((err) => {
              setLoading(false);
              Swal.fire("Error", err.response.data, "error", "OK");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'The approval has been cancelled', 'error');
        }
      });
    };
  
    return (
      <Container className="ContainerContent">
        {loading && (
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: '9999',
            }}
          />
        )}
        <Card className="CardContent2">
          <h1 className="TitleHeader">Supervisor Review Medical Claim</h1>
          <h1 className="SecondMiniTitleHeader">Update</h1>

          <Row className="my-3">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Staff Name</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              <Form.Control value={details?.employee?.fullname} readOnly disabled/>
            </Col>
          </Row>
  
          <Row className="my-3">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Invoice Date</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              {/* <Form.Control type="date" value={moment(details?.claim_date).format("YYYY-MM-DD")} readOnly disabled/> */}
              <DatePicker
                selected={details?.claim_date ? new Date(details?.claim_date) : null}
                dateFormat="yyyy-MM-dd"
                className={`form-control w-100 datepicker-icon`}
                readOnly
                disabled
              />
            </Col>
          </Row>
  
          <Row className="my-3">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Practitioner</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              <Form.Control value={details?.receipt_no} readOnly disabled/>
            </Col>
          </Row>
  
          <Row className="my-3">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Claim</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              <Form.Control value={details?.amount} readOnly disabled/>
            </Col>
          </Row>
  
          <Row className="my-3">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Receipt No</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              <Form.Control value={details?.receipt_reference} readOnly disabled/>
            </Col>
          </Row>
  
          {/* Conditional rendering based on attachment existence */}
          {attachment && attachment.file && (
            <Row className="my-3">
              <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
                {/* Display image */}
                {attachment.filetype.startsWith('image/') ? (
                  // <Image src={attachment.file} alt="Uploaded file" fluid />
                  // <iframe
                  //   src={pdfSrc}
                  //   title="PDF file"
                  //   width="100%"
                  //   height="500px"
                  // ></iframe>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '10px',
                      backgroundColor: '#373c40',
                      height: '500px',
                      width: "100%",
                      overflow: 'auto',
                    }}
                  >
                    <Image
                      src={attachment.file}
                      alt="Uploaded file"
                      fluid
                      style={{
                        maxWidth: '100%',
                        height: '100%',
                      }}
                    />
                  </div>
                ) : (
                  // Display PDF
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={attachment.file} height="500px" width="100%" />
                  </div>
                  // <iframe
                  //   src={`data:${attachment.filetype};base64,${attachment.file}`}
                  //   title="PDF file"
                  //   width="100%"
                  //   height="500px"
                  // ></iframe>
                )}
              </Col>
            </Row>
          )}
  
          <div className="d-flex justify-content-between">
            <ButtonGroup className="my-2">
              <Button className="Button" onClick={handleBtnBack}>
                Back
              </Button>
            </ButtonGroup>
  
            <ButtonGroup className="my-2">
              <Button className="Button" onClick={handleBtnReject} disabled={details?.status?.id !== 100}>
                Reject
              </Button>
              &nbsp; &nbsp;
              <Button className="Button" onClick={handleBtnApprove} disabled={details?.status?.id !== 100}>
                Approve
              </Button>
            </ButtonGroup>
          </div>
        </Card>
      </Container>
    );
  };
  export default SUReviewClaimForm;  